var map = {
	"./en.json": [
		1190,
		103
	],
	"./es.json": [
		1191,
		104
	],
	"./pt.json": [
		1192,
		105
	],
	"./widgets/en.json": [
		877,
		8
	],
	"./widgets/es.json": [
		878,
		9
	],
	"./widgets/pt.json": [
		879,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;